export const COOKIE_CONSENT = {
  storageKey: 'mpf_cookie_consent_v1',
  changedEvent: 'mpf:cookie-consent',
  openEvent: 'mpf:open-cookie-consent',
  privacyUrl: '/politica-de-privacidade',
  showDelayMs: 3000,
  // Mude ao alterar a política de privacidade/cookies: invalida as escolhas
  // antigas e o aviso volta a perguntar.
  policyVersion: '2026-09',
  maxAgeMs: 365 * 24 * 60 * 60 * 1000,
  title: 'Uso de cookies',
  textBefore:
    'Usamos cookies com propósitos estatísticos. Revise nossas políticas de ',
  linkLabel: 'privacidade e cookies',
  textAfter: '.',
  accept: 'Permitir todos',
  reject: 'Não permitir',
  customize: 'Personalizar',
  save: 'Salvar escolha',
  statisticsLabel: 'Estatísticos',
  statisticsHint: 'Medem o uso do portal para melhorá-lo.',
  thirdPartyLabel: 'Conteúdos de terceiros',
  thirdPartyHint:
    'Vídeos e outros conteúdos externos (YouTube, Vimeo), que gravam cookies do próprio provedor.',
  embedText: 'Este conteúdo é do {provider} e usa cookies de terceiros.',
  embedAccept: 'Permitir cookies e exibir',
  embedOpen: 'Abrir no {provider}',
} as const;
